import { useState, useEffect } from 'react'
import { Typography, Button, IconButton, Box, Stack,
         InputLabel, TextField, Select, Table, TableContainer,
         TableHead, TableBody, TableRow, TableCell, Pagination,
         Checkbox, FormControlLabel
       } from '@mui/material'
import { useConfirm } from '@/components/ConfirmProvider'
import OrgSelectModal from '@/components/Modal/OrgSelectModal'
import { admSend } from 'api/users';
import { useLocation, useNavigate } from 'react-router-dom'

/**
 * 권한 관리 등록 화면
 **/
function AuthMng () {
  const navigate = useNavigate();
  const location = useLocation();
  const { alert } = useConfirm();

  const searchYn = location.state?.searchYn;
  const navParamData = location.state?.navParamData;

  /* 기관검색 팝업 */
  const [dialogOpen, setDialogOpen] = useState(false);
  const handleOpenDialog = () => setDialogOpen(true);   // Dialog Open
  const handleCloseDialog = () => setDialogOpen(false);  // Dialog Close

  // 조회 조건
  const [paramData, setParamData] = useState({
    page : "", 
    authGradeCode : "",
    authGradeName : "",
    authGroupName : "",
  });     // 조회조건

  // 등록 정보.
  const [writeData, setWriteData] = useState({
    authGradeCode : "",
    authGradeName : "",
    authGroupName : "",
    authMenuList : []
  });     // 조회조건
  const [aprovMenuList, setAprovMenuList] = useState([]);   // 메뉴

// ====================== CSS ======================
  const headerCellStyle = {
    // width: '80px',
    bgcolor: 'grey.50'
    , borderTop: '1px solid'
    , borderColor: 'divider'
    // , cursor: 'pointer'
    , color: 'text.primary'
    , textAlign: 'center'
    , textDecoration: 'none'
  }

// ====================== 공통 함수 ======================
  // 개별 체크 변경 함수
  const handleCheckboxChange = (menuId, field, value) => {
    setAprovMenuList((prev) =>
      prev.map((menu) =>
        menu.menuId === menuId ? { ...menu, [field]: value } : menu
      )
    );
  };

// ====================== 사용자 업무 함수 ======================
  // 메뉴 정보 조회
  const searchMenu = async () => {
    try {
      const resData = await admSend('/getAllMenuList', writeData);
      setAprovMenuList(resData.data?.content);
    } catch (error) {
      console.error('권한정보 불러오기 실패:', error);
    }
  };

  // 메뉴권한 저장
  const saveAuth = async (data) => {

    if( validation() ){ return ''; }

    try {
      const result = await admSend('/saveAuth', data);
      
      if ( result ) {
        const alt = await alert("등록되었습니다.");
        if ( alt ) {
            navigate('/mng/authMng',   { state: { paramData : paramData} });
        }
      }

    } catch (error) {
      console.error('권한정보 등록 실패:', error);
    }
  };

  /* 유효성 검사 */
  const validation = () => {
    if( !writeData.authGradeName ) {
      alert('기관명이 선택되지 않았습니다.');
      return true;
    }

    if( !writeData.authGroupName ) {
      alert('권한명이 입력되지 않았습니다.');
      return true;
    }

      return false;
  }

// ====================== CallBack 함수 ======================
// 기관검색 다이얼로그에서 콜백
  const handleConfirmInstitution = (inst) => {
    setWriteData((p) => ({
      ...p,
      authGradeCode : inst.insttId,
      authGradeName : inst.insttNm
    }));
  };

  /* 최초 실행 */
  useEffect(() => {
    searchMenu();
  }, []);

  useEffect(() => {
    if( navParamData ) {
      setParamData({
        page : navParamData?.page, 
        authGradeCode : navParamData?.authGradeCode,
        authGradeName : navParamData?.authGradeName,
        authGroupName : navParamData?.authGroupName,
      });
    }
  }, [navigate]);

  return (
    <div>
      {/* 🔍 검색 조건 UI */}
      <Stack direction="row" alignItems="center" spacing={2}>
        <OrgSelectModal open={dialogOpen} onClose={handleCloseDialog} onSelect={handleConfirmInstitution} />
        {/* 기관 */}
        <Typography sx={{ width: 80 }}>기관명</Typography>
        <TextField
          sx={{ width: 580 }}
          id="insttName" 
          name="insttName" 
          label="기관명"
          value={writeData.authGradeName}
          onChange={(e) => {
            setWriteData({
              ...writeData,
              authGradeCode : e.target.value
            })
          }}
          disabled={true}
        />

        <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', gap: 1, mt: 2 }}>
          <Button 
            size="small"
            variant="outlined"
            onClick={handleOpenDialog}
            sx={{
              whiteSpace: 'nowrap',
              minWidth: 'auto',
              px: 2,
              py: 1,
              backgroundColor: '#FFF',
              '&:hover': {
                backgroundColor: '#FAFAFA'
              }
            }}
          >기관검색</Button>
        </Box>

      </Stack>

      <Stack direction="row" alignItems="center" spacing={2}>
        {/* 권한명 */}
        <InputLabel sx={{ width: 80 }}>권한명</InputLabel>
        <TextField
          id="insttCode" 
          name="insttCode" 
          sx={{ width: 580 }}
          label="권한명"
          value={writeData.authGroupName}
          onChange={(e) => {
            setWriteData({
              ...writeData,
              authGroupName : e.target.value
            })
          }}
        />
      </Stack>

      <TableContainer sx={{ mt: 3 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={headerCellStyle}>1Depth</TableCell>
              <TableCell sx={headerCellStyle}>2Depth</TableCell>
              <TableCell sx={headerCellStyle}>3Depth</TableCell>
              <TableCell sx={headerCellStyle} colSpan={2}>권한</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {
              aprovMenuList?.length === 0 ? (
                <TableRow>
                  <TableCell align="center" colSpan={4}>등록된 메뉴가 없습니다.</TableCell>
                </TableRow>
              ) : (
                aprovMenuList?.map((menu) => (
                  <TableRow key={menu.authGrpId}>
                    <TableCell align="center">{menu.menuLevel === "1" ? menu.menuName : ""}</TableCell>
                    <TableCell align="center">{menu.menuLevel === "2" ? menu.menuName : ""}</TableCell>
                    <TableCell align="center">{menu.menuLevel === "3" ? menu.menuName : ""}</TableCell>
                    <TableCell padding="checkbox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={menu.authEditYn === 'Y'}
                            onChange={(e) => {
                              const value = e.target.checked ? 'Y' : 'N';
                              handleCheckboxChange(menu.menuId, "authEditYn", value);
                            }}
                          />
                        }
                        label={"편집"}
                      />
                    </TableCell>
                    <TableCell padding="checkbox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={menu.authApovYn === 'Y'}
                            onChange={(e) => {
                              const value = e.target.checked ? 'Y' : 'N';
                              handleCheckboxChange(menu.menuId, "authApovYn", value);
                            }}
                          />
                        }
                        label={"승인"}
                      />
                    </TableCell>
                  </TableRow>

                ))
              )
            }
          </TableBody>
        </Table>
      </TableContainer>

      <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', gap: 1, mt: 2 }}>
        <Button
          sx={{ p: 3, border: '13px', borderRadius: '8px' }}
          variant="contained"
          color="primary"
          onClick={() => {
            navigate('/mng/authMng',   { state: { searchYn : searchYn, navParamData : navParamData} });
          }}
        >취소</Button>
        <Button
          sx={{ p: 3, border: '13px', borderRadius: '8px' }}
          variant="contained"
          color="primary"
          onClick={() => {
            const saveData = {
              ...writeData,
              authMenuList : aprovMenuList
            };
            saveAuth(saveData);
          }}
        >등록</Button>
      </Box>

    </div>

  )
}

export default AuthMng;